import Header from 'src/header';
import { Card } from 'src/components/Card';
import OrganizationBillingTab from 'src/components/pages/organizations/Billing';
import AdminHeader from './AdminHeader';
import { useCurrentOrganization } from 'src/contexts/OrganizationContext';

const BillingSubscriptions = () => {
  const organization = useCurrentOrganization();

  return (
    <div className="min-h-screen bg-gray-100">
      <Header isAdminPage={true} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <AdminHeader
          title="Billing & Subscriptions"
          description="Manage your organization's billing and subscription settings"
          organization={organization}
        />

        <Card className="w-full p-8">
          <OrganizationBillingTab organization={organization} />
        </Card>
      </div>
    </div>
  );
};

export default BillingSubscriptions;
